import React, { useState } from "react";
import { Panel, PanelBody, PanelHeader } from "../../../../util/panel";
import { Alert, Button, Col, Input, Row, Table } from "antd";
import { useApi } from "../../../../../hooks/http2";
import { displayTotal } from "../../../../../utils/helper";
import { FaExternalLinkAlt } from "react-icons/fa";
import SelectOption from "../../../../../components/SelectOption";
import dayjs from "dayjs";

const limit = 10;
const RegisterLinkPage = () => {
  const [page, setPage] = useState(1);
  const [sponsor, setSponsor] = useState("");
  const [upline, setUpline] = useState("");
  const [order, setOrder] = useState("");
  const [side, setSide] = useState("");
  const [linkStatus, setLinkStatus] = useState("");

  const { loading, fetch, error, reload } = useApi(
    {
      url: `/managements/distributors/register-link`,
      params: {
        offset: (page - 1) * limit,
        limit,
        sponsor,
        upline,
        order,
        side,
        link_status: linkStatus,
      },
    },
    [sponsor, upline, order, side, linkStatus, limit, page],
  );

  return (
    <Panel>
      <PanelHeader>สมัครสมาชิกแบบชำระเงินปลายทาง</PanelHeader>
      <PanelBody>
        <Row gutter={[16, 16]}>
          <Col span={24} md={8}>
            <Input.Search
              placeholder="ผู้แนะนำ (ชื่อ, รหัส)"
              onSearch={(value) => {
                setSponsor(value);
                setPage(1);
              }}
              allowClear
            />
          </Col>
          <Col span={24} md={8}>
            <Input.Search
              placeholder="อัปไลน์ (ชื่อ, รหัส)"
              onSearch={(value) => {
                setUpline(value);
                setPage(1);
              }}
            />
          </Col>
          <Col span={24} md={8}>
            <Input.Search
              placeholder="คำสั่งซื้อ"
              onSearch={(value) => {
                setOrder(value);
                setPage(1);
              }}
              allowClear
            />
          </Col>
          <Col span={24} md={4}>
            <SelectOption
              withAll
              allText="ทุกฝั่ง"
              data={[
                { value: "L", text: "ซ้าย (L)" },
                { value: "R", text: "ขวา (R)" },
              ]}
              className="w-100"
              value={side}
              onChange={(value) => {
                setSide(value);
                setPage(1);
              }}
              allowClear
            />
          </Col>
          <Col span={24} md={4}>
            <SelectOption
              withAll
              allText="ทุกสถานะ"
              data={[
                { value: "pending", text: "Pending" },
                { value: "success", text: "Success" },
              ]}
              className="w-100"
              value={linkStatus}
              onChange={(value) => {
                setLinkStatus(value);
                setPage(1);
              }}
            />
          </Col>
          <Col span={24} md={{ span: 3, offset: 13 }}>
            <Button block type="primary" ghost onClick={reload}>
              โหลดใหม่
            </Button>
          </Col>
        </Row>

        {error ? <Alert type="error" message={error} className="mt-2" /> : null}
        <Table
          size="small"
          bordered
          loading={loading}
          rowKey="row_id"
          dataSource={fetch?.list || []}
          className="mt-2"
          pagination={{
            total: fetch?.total || 0,
            size: "default",
            showLessItems: true,
            showTotal: displayTotal,
            pageSize: limit,
            current: page,
            onChange: (p) => setPage(p),
          }}
          scroll={{ x: "auto" }}
        >
          <Table.Column
            title="#"
            key="row_id"
            dataIndex="row_id"
            align="right"
          />
          <Table.Column
            title="ผู้แนะนำ"
            key="sponsor"
            dataIndex="sponsor_code"
            render={(sponsor_code, { sponsor_name }) => (
              <>
                รหัส: <strong>{sponsor_code}</strong>
                <br />
                ชื่อ: <strong>{sponsor_name}</strong>
              </>
            )}
          />
          <Table.Column
            title="อัปไลน์"
            key="upline"
            dataIndex="upline_code"
            render={(upline_code, { upline_name, side }) => {
              const _side = side === "L" ? "ซ้าย" : side === "R" ? "ขวา" : "-";
              return (
                <>
                  รหัส: <strong>{upline_code}</strong>
                  <br />
                  ชื่อ: <strong>{upline_name}</strong>
                  <br />
                  ฝั่ง:{" "}
                  <strong>
                    {_side} ({side})
                  </strong>
                </>
              );
            }}
          />
          <Table.Column
            title="สถานะลิงก์"
            key="link_status"
            dataIndex="link_status"
            align="center"
            render={(text) => (text === "success" ? "Success" : "Pending")}
          />
          <Table.Column
            title="รหัสที่เกิดจากการสมัคร"
            key="ref_partner_code"
            dataIndex="ref_partner_code"
            align="center"
          />
          <Table.Column
            title="คำสั่งซื้อ"
            key="order"
            dataIndex="order_code"
            render={(order_code, { order_date }) => (
              <>
                เลขที่: <strong>{order_code}</strong>
                <br />
                <small>
                  {" "}
                  วันที่:{" "}
                  <strong>
                    {dayjs(order_date).format("DD/MM/YYYY HH:mm")}
                  </strong>
                </small>
              </>
            )}
          />
          <Table.Column
            title={<FaExternalLinkAlt />}
            key="link"
            dataIndex="redirect_url"
            align="center"
            render={(text, { link_status }) =>
              text && link_status !== "success" ? (
                <Button size="small" type="link" href={text} target="_blank">
                  <FaExternalLinkAlt />
                </Button>
              ) : null
            }
          />
        </Table>
      </PanelBody>
    </Panel>
  );
};

export default RegisterLinkPage;
